import { render, staticRenderFns } from "./BusinessJoinStep4.vue?vue&type=template&id=fd4d3b8c&"
import script from "./BusinessJoinStep4.vue?vue&type=script&lang=js&"
export * from "./BusinessJoinStep4.vue?vue&type=script&lang=js&"
import style0 from "./BusinessJoinStep4.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports